import { setAttributes } from '@/scripts/Utils'

export default function() {
  document.head.appendChild(
    setAttributes(document.createElement('script'), {
      src: 'https://www.algolia.com/assets/cookies_consent.js'
    })
  )
  document.head.appendChild(
    setAttributes(document.createElement('link'), {
      rel: 'stylesheet',
      type: 'text/css',
      href: 'https://www.algolia.com/assets/cookies_consent.css'
    })
  )
}
